<!--
 * @Author: Peng Bo Wei
 * @Date: 2021-11-01 09:14:50
 * @LastEditors: Peng Bo Wei
 * @LastEditTime: 2021-11-05 11:41:14
 * @Description: 
-->

<template>
  <el-dialog
    :title="title"
    :visible.sync="subDialogVisible"
    :before-close="handleClose"
  >
    <table-form
      :dataSource="dataSource"
      ref="form"
      :tableData="data"
    ></table-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TableForm from "common/components/form/tableForm3";
import { subzqstep2, subgqstep2 } from "@/conf/Report-manager";
import { nation, selectDic, addUpProduct, addUpdateMes } from "common/js/api";
import { saveReportMgrFund, updateMgrFund } from "common/js/api";
export default {
  components: {
    TableForm,
  },

  props: ["subDialogVisible", "title", "data", "codeId", "parentFundId"],

  data() {
    return {
      dataSource: [],
      dialogFormVisible: false,
      formData: {},
    };
  },

  mounted() {
    this.setConf();
  },

  methods: {
    async setConf() {
      const fillType = this.$store.state.ReportData.reportFillType;
      console.log("tian jia getFillType using", fillType);

      if (fillType == "gq") {
        this.dataSource = subgqstep2;
      }
      if (fillType == "zq") {
        this.dataSource = subzqstep2;
      }
    },

    async submit() {
      const isValidate = this.$refs.form.submitForm();
      if (!isValidate) return false;
      let form = this.$refs.form.form;
      console.log("添加子基金报文", form);

      // code id
      form.reportCode = this.codeId;
      form.parentFundId = this.parentFundId;
      //
      if (form.associtionRegisted == "是") {
        form.associtionRegisted = 1;
      }
      if (form.associtionRegisted == "否") {
        form.associtionRegisted = 0;
      }
      if (form.mgrRegisted == "是") {
        form.mgrRegisted = 1;
      }
      if (form.mgrRegisted == "否") {
        form.mgrRegisted = 0;
      }
      if (this.title.includes("编辑")) {
        form.id = this.data.id;
        console.log("添加基金机构报文", form);
        const ret = await updateMgrFund(form);
        console.log("添加基金机构报文完成", ret);
      } else {
        console.log("添加基金机构报文", form);

        const ret = await saveReportMgrFund(form);
        console.log("添加基金机构报文完成", ret);
      }

      const message = this.title.includes("添加") ? "添加" : "编辑";
      this.$message({
        message: `已发行产品${message}成功!`,
        type: "success",
      });
      this.$emit("reload");
      this.handleClose();
    },

    handleClose() {
      this.formData = {};
      this.dialogFormVisible = false;
      this.$emit("closeDialog");
    },
  },

  watch: {
    subDialogVisible(newValue) {
      this.dialogFormVisible = newValue;
    },
  },
};
</script>

